export const hashCode = function (string: string) {
  let hash = 0,
    i,
    chr;

  if (string.length === 0) return hash;

  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

export const isString = (val: unknown): val is string =>
  val !== undefined && val !== null && typeof val === "string";

export const isValidString = (str?: unknown, min?: number, max?: number): str is string => {
  if (typeof str !== "string") return false;
  if (!!str && isString(str) && str.trim().length > 0) {
    const length = str.trim().length;

    if (min !== undefined && min !== -1 && min > length) return false;
    if (max !== undefined && max !== -1 && max < length) return false;

    return true;
  }

  return false;
};

export const isStringWithoutSpecialCharsAndNumbers = (
  str: unknown,
  min?: number,
  max?: number,
  specificSize?: number
): str is string => {
  if (isValidString(str, min, max)) {
    const regex = /^[\p{L}\p{M}\p{Zs}]+$/u;

    return specificSize ? regex.test(str.slice(0, specificSize)) : regex.test(str);
  } else {
    return false;
  }
};

export const removeSpaceCharacter = (val: string): string => val.replace(/\s/g, "");

export const removeAccent = (val: string): string => val.normalize("NFD").replace(/\p{Diacritic}/gu, "");

export const capitalizeFirstLetter = function (val?: string) {
  return val ? val.charAt(0).toUpperCase() + val.slice(1) : "";
};

export const ensureStringValue = <V = string | unknown, D = string | unknown>(
  value: V,
  defValue: D = "" as D
): string | D => {
  if (!isValidString(value)) return defValue;

  return value;
};
